import { h } from 'preact'
import { t } from '../../libs/translationsUtils/translations'

const TopicClosed = () => (
  <div className='box box--info box--rounded'>
    <div className='box__pad qa-mesg-topic-closed' dangerouslySetInnerHTML={{ __html: t('Forum', 'topic.closed.info_message') }} />
  </div>
)

export default TopicClosed
